import axios from 'axios';

// Environment-aware configuration to handle proxy vs ingress
const getBaseURL = () => {
  // Check if we're running locally (either dev server or local serve)
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  const baseURL = (process.env.NODE_ENV === 'development' || isLocal)
    ? 'http://localhost:8080/api'  // Development or local serve: direct to API server
    : '/api';                      // Production: through ingress
  
  console.log(`🔧 NODE_ENV: ${process.env.NODE_ENV}, hostname: ${window.location.hostname}, isLocal: ${isLocal}, using baseURL: ${baseURL}`);
  return baseURL;
};

const instance = axios.create({
  baseURL: getBaseURL(),
  timeout: 20000,   // 20 seconds to handle slow database queries
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Add a response interceptor for better error handling
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('API Error Response:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      // The request was made but no response was received
      console.error('API Error Request:', {
        request: error.request,
        message: error.message
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('API Error:', error.message);
    }
    // On 401 (unauthenticated) redirect to the login page, unless we're already there.
    const status = error?.response?.status;
    if (status === 401 && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    // 429 (too many requests) falls through to callers to show a "too many requests" message.
    return Promise.reject(error);
  }
);

export default instance; 